import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {RequesterService} from '../../services/requester.service';
import {JourneyPageModel} from '../journey/models/journey-page.model';

@Injectable({
    providedIn: 'root'
})
export class QuizService {
    constructor(
        private router: Router,
        private requesterService: RequesterService,
    ) {
    }

    getMyJourneyStage(stage: number, template_id: number): Promise<JourneyPageModel> {
        return this.requesterService.get('getMyJourneyStage', {stage, template_id})
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error getMyJourneyStage >> ', e);
            });
    }
}
